import { ItemStockReportViewModel } from './ItemStockReportViewModel';

export class StockReportTotalViewModel {
  public TotalitemPrice: number;
  public TotalInQuantity: number;
  public TotalAssignQuantity: number;
  public TotalQuantity: number;
  public TotalAmount: number;
  public StockReportList: ItemStockReportViewModel[];
}



export class GetItemStockReport {
  public totalItemPrice: number;
  public totalInQuantity: number;
  public totalAssignQuantity: number;
  public totalQuantity: number;
  public totalAmount: number;
  public stockReportList: StockReportModel[];
}

export class StockReportModel {

  public id: number;
  public itemCode: string;
  public itemName: string;
  public itemPrice: number;
  public inQuantity: number;
  public assignQuantity: number;
  public totalQuantity: number;
  public totalAmount: number;
}
